/**
 * Defines the constants used by the Users module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */


export const VUEX_USER_ADMIN_UPDATE                              = 'VUEX_USER_ADMIN_UPDATE'
export const VUEX_USER_CREATE_CANCEL                             = 'VUEX_USER_CREATE_CANCEL'
export const VUEX_USER_CREATE_CANCEL_ABORT                       = 'VUEX_USER_CREATE_CANCEL_ABORT'
export const VUEX_USER_CREATE_CANCEL_PROMPT                      = 'VUEX_USER_CREATE_CANCEL_PROMPT'
export const VUEX_USER_CREATE_END                                = 'VUEX_USER_CREATE_END'
export const VUEX_USER_CREATE_REQUEST                            = 'VUEX_USER_CREATE_REQUEST'
export const VUEX_USER_CREATE_REQUEST_FAILURE                    = 'VUEX_USER_CREATE_REQUEST_FAILURE'
export const VUEX_USER_CREATE_REQUEST_SUCCESS                    = 'VUEX_USER_CREATE_REQUEST_SUCCESS'
export const VUEX_USER_CREATE_ROLE_REQUEST                       = 'VUEX_USER_CREATE_ROLE_REQUEST'
export const VUEX_USER_CREATE_ROLE_REQUEST_FAILURE               = 'VUEX_USER_CREATE_ROLE_REQUEST_FAILURE'
export const VUEX_USER_CREATE_ROLE_REQUEST_SUCCESS               = 'VUEX_USER_CREATE_ROLE_REQUEST_SUCCESS'
export const VUEX_USER_CREATE_START                              = 'VUEX_USER_CREATE_START'
export const VUEX_USER_CREATE_SUCCESS                            = 'VUEX_USER_UPDATE_CREATE_SUCCESS'
export const VUEX_USERS_GET_USERS_BY_ROLE_AND_DEPARTMENT         = 'VUEX_USERS_GET_USERS_BY_ROLE_AND_DEPARTMENT'
export const VUEX_USERS_GET_USERS_BY_ROLE_AND_DEPARTMENT_SUCCESS = 'VUEX_USERS_GET_USERS_BY_ROLE_AND_DEPARTMENT_SUCCESS'
export const VUEX_USER_DELETE_ROLE_REQUEST                       = 'VUEX_USER_DELETE_ROLE_REQUEST'
export const VUEX_USER_DELETE_ROLE_REQUEST_FAILURE               = 'VUEX_USER_DELETE_ROLE_REQUEST_FAILURE'
export const VUEX_USER_DELETE_ROLE_REQUEST_SUCCESS               = 'VUEX_USER_DELETE_ROLE_REQUEST_SUCCESS'
export const VUEX_USER_GET_REQUEST                               = 'VUEX_USER_GET_REQUEST'
export const VUEX_USER_GET_REQUEST_FAILURE                       = 'VUEX_USER_GET_REQUEST_FAILURE'
export const VUEX_USER_GET_REQUEST_SUCCESS                       = 'VUEX_USER_GET_REQUEST_SUCCESS'
export const VUEX_USER_GOTO_CREATE_ROUTE                         = 'VUEX_USER_GOTO_CREATE_ROUTE'
export const VUEX_USER_GOTO_UPDATE_ROUTE                         = 'VUEX_USER_GOTO_UPDATE_ROUTE'
export const VUEX_USER_PASSWORD_RESET_REQUEST                    = 'VUEX_USER_PASSWORD_RESET_REQUEST'
export const VUEX_USER_PASSWORD_RESET_REQUEST_FAILURE            = 'VUEX_USER_PASSWORD_RESET_REQUEST_FAILURE'
export const VUEX_USER_PASSWORD_RESET_REQUEST_SUCCESS            = 'VUEX_USER_PASSWORD_RESET_REQUEST_SUCCESS'
export const VUEX_USER_REQUEST_ACCESS                            = 'VUEX_USER_REQUEST_ACCESS'
export const VUEX_USER_REQUEST_ACCESS_REQUEST                    = 'VUEX_USER_REQUEST_ACCESS_REQUEST'
export const VUEX_USER_REQUEST_ACCESS_REQUEST_FAILURE            = 'VUEX_USER_REQUEST_ACCESS_REQUEST_FAILURE'
export const VUEX_USER_REQUEST_ACCESS_REQUEST_SUCCESS            = 'VUEX_USER_REQUEST_ACCESS_REQUEST_SUCCESS'
export const VUEX_USER_SELF_UPDATE                               = 'VUEX_USER_SELF_UPDATE'
export const VUEX_USER_SET_RESET_PASSWORD_STATUS                 = 'VUEX_USER_SET_RESET_PASSWORD_STATUS'
export const VUEX_USER_UPDATE_CANCEL                             = 'VUEX_USER_UPDATE_CANCEL'
export const VUEX_USER_UPDATE_CANCEL_ABORT                       = 'VUEX_USER_UPDATE_CANCEL_ABORT'
export const VUEX_USER_UPDATE_CANCEL_PROMPT                      = 'VUEX_USER_UPDATE_CANCEL_PROMPT'
export const VUEX_USER_UPDATE_END                                = 'VUEX_USER_UPDATE_END'
export const VUEX_USER_UPDATE_PROP                               = 'VUEX_USER_UPDATE_PROP'
export const VUEX_USER_UPDATE_PROP_REQUEST                       = 'VUEX_USER_UPDATE_PROP_REQUEST'
export const VUEX_USER_UPDATE_PROP_REQUEST_FAILURE               = 'VUEX_USER_UPDATE_PROP_REQUEST_FAILURE'
export const VUEX_USER_UPDATE_PROP_REQUEST_SUCCESS               = 'VUEX_USER_UPDATE_PROP_REQUEST_SUCCESS'
export const VUEX_USER_UPDATE_START                              = 'VUEX_USER_UPDATE_START'

export const VUEX_USERS_SET_FILTER_TOGGLER                       = 'VUEX_USERS_SET_FILTER_TOGGLER'
export const VUEX_USERS_APPLY_FILTERS                            = 'VUEX_USERS_APPLY_FILTERS'
export const VUEX_USERS_CLEAR_FILTERS                            = 'VUEX_USERS_CLEAR_FILTERS'
export const VUEX_USERS_APPLY_DEPARTMENT_FILTER                  = 'VUEX_USERS_APPLY_DEPARTMENT_FILTER'
export const VUEX_USERS_APPLY_DEPARTMENT_ROLE_FILTER             = 'VUEX_USERS_APPLY_DEPARTMENT_ROLE_FILTER'
export const VUEX_USERS_APPLY_ROLE_FILTER                        = 'VUEX_USERS_APPLY_ROLE_FILTER'
export const VUEX_USERS_APPLY_STATUS_FILTER                      = 'VUEX_USERS_APPLY_STATUS_FILTER'
export const VUEX_USERS_APPLY_TYPE_FILTER                        = 'VUEX_USERS_APPLY_TYPE_FILTER'
export const VUEX_USERS_APPLY_ACCESS_FILTER                      = 'VUEX_USERS_APPLY_ACCESS_FILTER'


export const VUEX_USERS_GET_REQUEST                              = 'VUEX_USERS_GET_REQUEST'
export const VUEX_USERS_APPLY_DEEPSTATE                          = 'VUEX_USERS_APPLY_DEEPSTATE'
export const VUEX_USERS_GET_REQUEST_FAILURE                      = 'VUEX_USERS_GET_REQUEST_FAILURE'
export const VUEX_USERS_GET_REQUEST_SUCCESS                      = 'VUEX_USERS_GET_REQUEST_SUCCESS'

export const VUEX_USERS_GET_USERS_BY_ROLE                        = 'VUEX_USERS_GET_USERS_BY_ROLE'
export const VUEX_USERS_GET_USERS_BY_ROLE_SUCCESS                = 'VUEX_USER_GET_USERS_BY_ROLE_SUCCESS'
export const VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE                 = 'VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE'
export const VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE_SUCCESS         = 'VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE_SUCCESS'
export const VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING             = 'VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING'
export const VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING_SUCCESS     = 'VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING_SUCCESS'

export const VUEX_USERS_SYNC_PAGINATION                          = 'VUEX_USERS_SYNC_PAGINATION'
export const VUEX_USERS_SYNC_PAGINATION_SORT                     = 'VUEX_USERS_SYNC_PAGINATION_SORT'
export const VUEX_USERS_EMPLOYEES_PAGINATION_EXIT                = 'VUEX_USERS_EMPLOYEES_PAGINATION_EXIT'

export const VUEX_USERS_GET_USERS_BY_EMPLOYEE_TYPE               = 'VUEX_USERS_GET_USERS_BY_EMPLOYEE_TYPE'
export const VUEX_USERS_GET_USERS_BY_EMPLOYEE_TYPE_SUCCESS       = 'VUEX_USERS_GET_USERS_BY_EMPLOYEE_TYPE_SUCCESS'

export const VUEX_USERS_EXIT_USERS                               = 'VUEX_USERS_EXIT_USERS'

// Search
export const VUEX_USERS_GET_SEARCH                               = 'VUEX_USERS_GET_SEARCH'
export const VUEX_USERS_GET_SEARCH_SUCCESS                       = 'VUEX_USERS_GET_SEARCH_SUCCESS'
export const VUEX_USERS_GET_SEARCH_FAILURE                       = 'VUEX_USERS_GET_SEARCH_FAILURE'
export const VUEX_USERS_CLEAR_SEARCH_DATA                        = 'VUEX_USERS_CLEAR_SEARCH_DATA'
export const VUEX_USERS_UPDATE_SEARCH_TERM                       = 'VUEX_USERS_UPDATE_SEARCH_TERM'


// ATTACHMENTS
export const VUEX_USER_ATTACH_FILE                               = 'VUEX_USER_ATTACH_FILE'
export const VUEX_USERS_HANDLE_FILE_NOTIFICATION                 = 'VUEX_USERS_HANDLE_FILE_NOTIFICATION'
export const VUEX_USER_REFRESH_CURRENT_USER_AVATAR               = 'VUEX_USER_REFRESH_CURRENT_USER_AVATAR'

//BATCH REASSIGN USER
export const VUEX_USER_BATCH_REASSIGN                            = 'VUEX_USER_BATCH_REASSIGN'
export const VUEX_USER_BATCH_REASSIGN_OPEN                       = 'VUEX_USER_BATCH_REASSIGN_OPEN'
export const VUEX_USER_BATCH_REASSIGN_CLOSE                      = 'VUEX_USER_BATCH_REASSIGN_CLOSE'